import type {
    CarModelLabelType,
    ColourType,
    ExtraBaseType,
    ExtraType,
    PackType,
    PriceType,
    PromotionType,
    ServiceProductType,
    UpholsteryType,
    WheelType,
    WinterWheelType,
} from "../../../common-deprecated/types/CommonTypes";
import type { SortedSpecType } from "../../../common-deprecated/types/SpecTypes";
import { type CertificationType, getDefaultPriceObject } from "../../../common-deprecated/constants";

export enum SteeringPosition {
    Left = "L",
    Right = "R",
}
export type CarModelType = {
    id: string;
    name: string;
    webtitleSectionName: string;
    configVersion: string;
    internalCode: string;
    defaultCCISBackground: string; // For example white-studio
    labels: CarModelLabelType[];
    defaultCar: string;
    steering: SteeringPosition;
};

export type CarSubmodelType = {
    id: string;
    name: string;
    internalCode: string;
};

export type CarBodyType = {
    id: string;
    name: string;
    webtitleSectionName: string;
};

export type CarGradeType = {
    id: string;
    name: string;
    webtitleSectionName: string;
};

export type CarMotorizationType = {
    engine: {
        id: string;
        name: string;
        type: string;
        typeId: string;
        typeCode: string;
        hybrid: boolean;
        electric: boolean;
        fuelCell: boolean;
        plugin: boolean;
        internalCode: string;
    };
    transmission: {
        id: string;
        internalCode: string;
        name: string;
    };
    wheeldrive: {
        id: string;
        internalCode: string;
        name: string;
        description: SanitizedString;
    };
};

export type CarType = {
    id: string;
    shortId: number;
    name: string;
    certification: CertificationType;
    price: PriceType;
    efficiencyClass: string;
    // Todo in the formatCar method, the finance object is always empty (= null)...
    // finance: ,
    availableForOnlineSales: boolean;
    availableForOnlineReservation: boolean;
    availableForOnlineLeasing: boolean;
    availability: {
        showAccessoriesRateCarConfig: boolean;
        showAnnualInterestRate: boolean;
        showEffectiveInterestRate: boolean;
        showFinanceButton: boolean;
        showInsuranceButton: boolean;
        showMonthlyRate: boolean;
        showProductName: boolean;
        showTerm: boolean;
        showInsurancePremiumCarConfig: boolean;
    };
    model: CarModelType;
    submodel: CarSubmodelType | null;
    grade: CarGradeType;
    body: CarBodyType;
    motorization: CarMotorizationType;
    colour: ColourType;
    upholstery: UpholsteryType;
    wheel: WheelType;
    packs: PackType[];
    financePacks: PackType[];
    serviceProducts: ServiceProductType[];
    extras: ExtraType[];
    eco: SortedSpecType[];
    winterWheel: WinterWheelType | null;
    // This is used to store the car loaded with a tyCode, used for basket parsing.
    tyCodeCar?: CarType;
    manualPromotions: PromotionType[];
    // Property used to identify that the model is a convertible an can switch between the roof expanded and collapsed
    visibleInTopSpin: boolean;
    soldOut?: boolean;
};

export const initialExtraBase: ExtraBaseType = {
    id: "",
    shortId: "",
    code: "",
    name: "",
    index: 0,
    type: "" as any,
    price: { ...getDefaultPriceObject() },
    standard: false,
    visualisation: [],
    image: "",
    included: [],
    excluded: [],
    includePacks: [],
    excludePacks: [],
    description: null,
    footNote: null,
    availability: {
        colours: [],
        upholsteries: [],
    },
    sortIndex: 0,
};
